//@flow
import { call, put, takeLatest, all } from "redux-saga/effects";

import {
  COFFEE_GET_MATCH_REQUESTING,
  COFFEE_GET_MATCH_ERROR,
  COFFEE_GET_MATCH_SUCCESS,
} from "./constants";

import { fetchApi } from "../api";

const endPoints = {
  getMatch: "/v1/random-coffee/match/", // clientId // userId // lastMatchId
};

const getMatchApi = payload => {
  const { userId, clientId, lastMatchId } = payload;
  return fetchApi(
    `${endPoints.getMatch}${clientId}/${userId}/${lastMatchId}`,
    {},
    "get",
  );
};

function* getMatchFlow(action) {
  try {
    const success = yield call(getMatchApi, action.payload);
    yield put({ type: COFFEE_GET_MATCH_SUCCESS, payload: success });
  } catch (error) {
    console.log(error);
    yield put({ type: COFFEE_GET_MATCH_ERROR, payload: error });
  }
}

function* notificationsWatcher() {
  yield all([takeLatest(COFFEE_GET_MATCH_REQUESTING, getMatchFlow)]);
}

export default notificationsWatcher;
